
const Main = () => import('@/views/main');
const OperationMonitoring = () => import('@/views/operation-management/operation-monitoring');
const OperationWarnStatistics = () => import('@/views/operation-management/operation-warn-statistics');

export default [{
    path: '/operationManagement',
    name: 'operationManagement',
    redirect: {
        name: 'operationMonitoring'
    },
    component: Main,
    meta: {
        hide: false,
        name: '运行管理',
        unfold: true,
        iconType: '16'
    },
    children: [
        {
            path: 'operationMonitoring',
            name: 'operationMonitoring',
            component: OperationMonitoring,
            meta: {
                name: '运行监控'
            },
        },
        {
            path: 'operationWarnStatistics',
            name: 'operationWarnStatistics',
            component: OperationWarnStatistics,
            meta: {
                name: '告警统计'
            },
        },
    ]
}]

